import axios from "axios";
import Config from "../config"
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();
export default class TagService {
    constructor() {
      this.loginStore = null;
    }

    store() {
      if(!this.loginStore) { this.loginStore = useLoginStore(); };
      return this.loginStore;
    }
    
    fetchDeleteTag(tag_name) {
        let bodyTosend = {
            "tag_name": tag_name
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("deleteTag"),
                bodyTosend,
                options
            )
            .then(res => res.data);
    }
    fetchTags() {
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        }
        return axios
            .post(
                Config.url("listTags"),
                {},
                options
            )
            .then(res => res.data);
    }
    fetchCreateTag(tag_name) {
        let bodyTosend = {
            "tag_name": tag_name,
            // "entity": entity,
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("createTag"),
                bodyTosend,
                options
            )
            .then(res => res);
    }
    fetchAssociateTagWithFilters(tag_name, entity, filters) {
        let bodyTosend = {
            "tag_name": tag_name,
            "entity": entity,
            "filters": filters,
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("associateTag"),
                bodyTosend,
                options
            )
            .then(res => res);
    }
    fetchAssociateTag(tag_name, entity, entity_code) {
        let bodyTosend = {
            "tag_name": tag_name,
            "entity": entity,
            "entity_code": entity_code,
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("associateTag"),
                bodyTosend,
                options
            )
            .then(res => res);
    }
    fetchDisassociateTag(tag_name, entity, entity_code) {
        let bodyTosend = {
            "tag_name": tag_name,
            "entity": entity,
            "entity_code": entity_code,
        };
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{},
            }
        };
        return axios
            .post(
                Config.url("disassociateTag"),
                bodyTosend,
                options
            )
            .then(res => res);
    }
}
